import React from 'react'
import {DateRangePicker as ReactDatePicker, DateRangePickerShape} from 'react-dates'
import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'

const DatePicker = ReactDatePicker as React.ComponentClass<DateRangePickerShape>

export const DateRangePicker: React.FC<DateRangePickerShape> = (props) => {
  return <DatePicker {...props} />
}

export default DateRangePicker
